import { put, call } from 'redux-saga/effects'
import LoginActions from '../../reducers/login/LoginRedux'
import { UserActions } from '../../reducers/user/index'
import Api from '../../services/ApiCaller'

export function * requestLogin (api, {email, password}) {
  yield call(Api.callServer, api.verifyUser, {email, password}, function * (data) {
    const {token, isMaster, masterToken, ...user} = data

    if (data) {
      if (token || masterToken) {
        localStorage.clear();
        if(isMaster) {
          localStorage.setItem('is_master', isMaster)
          localStorage.setItem('login_token', masterToken)
        } else {
          localStorage.setItem('login_token', token)
        }
        localStorage.setItem('role', user.role)
        localStorage.setItem('id', user.id)
        localStorage.setItem("email", user.email)
        // localStorage.setItem('login', JSON.stringify(user.campaign || {}))
        if(isMaster) {
          yield put(LoginActions.createLoginSuccess({token: masterToken, role: user.role, user}))
        } else {
          yield put(LoginActions.createLoginSuccess({token, role: user.role, user}))
        }
        yield put(UserActions.getUserSuccess(user))
      } else { yield put(LoginActions.createLoginError('Something went wrong. Please try again')) }
    }
  }, function * (error) {

    // let user = {
    //   'id': '5bacc98d66cc93c9624eb073',
    //   'email': 'admin@gttv.com',
    //   'name': {
    //     'first': 'Admin',
    //     'last': 'User'
    //   },
    //   'fullName': 'Admin User',
    //   'picture': {},
    //   'homeAddress': {
    //     'geo': []
    //   },
    //   'isAdmin': true,
    //   'role': 'admin',
    //   'createdAt': '2018-09-27T12:14:05.988Z',
    //   'token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjViYWNjOThkNjZjYzkzYzk2MjRlYjA3MyIsImlhdCI6MTUzODEwNzc1OX0.PpccPfyRq1ugb9a2WNGM2EmDAtkbMBsZZL_EVmAfFgM'
    // }
    //
    // if (user) {
    //   const {token, role} = user
    //   if (user.token) {
    //     localStorage.setItem('login_token', token)
    //     localStorage.setItem('role', role)
    //     yield put(LoginActions.createLoginSuccess({token, role: role}))
    //     yield put(UserActions.getUserSuccess(user))
    //   } else { yield put(LoginActions.createLoginError('Something went wrong. Please try again')) }
    // }

    yield put(LoginActions.createLoginError(error))
  })
}

export function * successLogin (api, {loginToken}) {
  const {token} = loginToken
  yield api.setHeader('Authorization', 'Bearer ' + token)
}

export function * requestLogout (api) {
  yield call(Api.callServer, api.logoutUser, {}, function * () {
    localStorage.clear()
    sessionStorage.clear()
    yield put(LoginActions.createLogoutSuccess())
  }, function * (error) {
    yield put(LoginActions.createLogoutError(error))
  })
}

export function * successLogout (api) {
  localStorage.clear()
  sessionStorage.clear()
  yield put(LoginActions.createLogoutSuccess())
  api.setHeader('authorization', '')
  yield put(UserActions.clearUser())
}

export function * requestRegister (api, {firstName, lastName, email, password}) {
  yield call(Api.callServer, api.registerUser, {firstName, lastName, email, password}, function * (data) {
    const {user, auth} = data
    if (data) {
      const {access_token} = auth
      if (access_token) {
        localStorage.setItem('login_token', access_token)
        yield put(LoginActions.createLoginSuccess(access_token))
        yield put(UserActions.getUserSuccess(user))
      } else { yield put(LoginActions.createRegisterError('Invalid Registration Token')) }
    }
  }, function * (error) {
    yield put(LoginActions.createRegisterError(error))
  })
}

export function * requestForgotPassword (api, {email}) {
  yield call(Api.callServer, api.forgotUser, {email}, function * (data) {
    yield put(LoginActions.createForgotSuccess(data))
  }, function * (error) {
    yield put(LoginActions.createForgotError(error))
  })
}

export function * requestResetPassword (api, {password, forgotToken}) {
    yield call(Api.callServer, api.resetUser, {password, forgotToken}, function * (data) {
        yield put(LoginActions.resetPasswordSuccess(data))
    }, function * (error) {
        yield put(LoginActions.resetPasswordError(error))
    })
}